import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_WORKSPACE_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/enquete`;
export default{
    async listar(){
        return await Vue.prototype.$httpJson.get(baseUrl);
    },    
    async listarPorId(id){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/${encodeURI(id)}`);
    },
    async listarPorUsuario(){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/dashboard`);
    },           
    async listarAcessosUsuario(){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/usuario`);
    },      
    async dashboard(idEnquete, dataInicial, dataFinal, idPais, idEmpresa, idDivisao, idLocalidade){
        let queryString = "?";

        if(idPais != null && idPais != undefined){
            queryString += `idPais=${encodeURI(idPais)}&`;
        }

        if(idEmpresa != null && idEmpresa != undefined){
            queryString += `idEmpresa=${encodeURI(idEmpresa)}&`;
        }        

        if(idDivisao != null && idDivisao != undefined){
            queryString += `idDivisao=${encodeURI(idDivisao)}&`;
        }                

        if(idLocalidade != null && idLocalidade != undefined){
            queryString += `idLocalidade=${encodeURI(idLocalidade)}&`;
        }                        

        if(queryString.length == 1){
            queryString = "";
        }
        else {
            queryString = queryString.substring(0, queryString.length - 1);
        }

        return await Vue.prototype.$httpJson.get(`${baseUrl}/dashboard/${encodeURI(idEnquete)}/${encodeURI(dataInicial)}/${encodeURI(dataFinal)}${queryString}`);
    }        
}